export const UPDATE_INCLUDE_IN_SCENARIO = 'UPDATE_INCLUDE_IN_SCENARIO';
export const MODEL_INCLUDE_IN_SCENARIO = 'MODEL_INCLUDE_IN_SCENARIO';
export const SET_INITIAL_INCLUDE_IN_SCENARIO = 'SET_INITIAL_INCLUDE_IN_SCENARIO';

export const updateIncludeInScenario = (data: any) => ({
    type: UPDATE_INCLUDE_IN_SCENARIO,
    payload: data
})

export const modelIncludeInScenario = () => ({
    type: MODEL_INCLUDE_IN_SCENARIO
})

export const setInitialIncludeInScenario = (data: any) => ({
    type: SET_INITIAL_INCLUDE_IN_SCENARIO,
    payload: data
})